module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__settings .table > div > div {\n        padding : 5px 10px;\n    }\n\n    .settings-page > div {\n        margin : 5px 0;\n    }\n\n    .settings-page .export-column {\n        overflow: hidden;\n        text-overflow: ellipsis\n    }\n</style>\n\n<div class=\"form__page spl-form__page spl-form__page__settings\">\n    <div>\n        <label>\n            Формат выгрузки\n            <control type=\"enum-select\" target=\"options.driver\" enum=\"Spatial.ImExDriver\" show-empty=\"true\" on-select=\"onDriverSelect\"/>\n        </label>\n    </div>\n    <div>\n        <label>\n            Проекция\n            <control type=\"data-autocomplete\" target=\"options.projectionname\" source=\"GIS.Data.Projections\"\n                     column=\"name\" columns=\"name\" bind=\"options.projection:code\" strict=\"true\"/>\n        </label>\n    </div>\n    <div> Колонки</div>\n\n    ")
    ;  _.each(widget.options.columns, function(col, i) { 
    ; __append("\n    <div class=\"export-column\">\n        <label>\n            <control type=\"checkbox\" target=\"options.columns.")
    ; __append(escapeFn( i ))
    ; __append(".enabled\" ")
    ; __append( col.fixed ? 'html-disabled="disabled"' : '' )
    ; __append(" /> ")
    ; __append(escapeFn( col.label ))
    ; __append("\n        </label>\n    </div>\n    ")
    ;  }) 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}